import { render, staticRenderFns } from "./layerbmap.vue?vue&type=template&id=2356e651"
import script from "./layerbmap.vue?vue&type=script&lang=js"
export * from "./layerbmap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports